import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Button, Grid, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import { EKYCBiomateric as EKYCBIOMATERIC } from 'Components/Api/ApiClubAEPSAPI';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import CircularProgress from '@material-ui/core/CircularProgress';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
const CustomContainer = HOCLoader(Container);

export const ApiClubBiomatric = () => {
    const history = useHistory();
    const classes = commonStyle();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const TransactionID = location?.state?.TransactionID;
    const MobileNo = location?.state?.MobileNo;
    const AadhaarNo = location?.state?.AadhaarNo;

    const [formObject, setFormObject] = useState({
        TransactionID: TransactionID,
        AadhaarNo: AadhaarNo,
        MobileNo: MobileNo,
        FingerPrint: ''
    });

    const submithandle = async (values, { resetForm }) => {
        setIsError(false);
        setResponseMessage('');
        setLoading(true);

        const { status, xmldata } = await GetFingerPrint(
            'E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc='
        );

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        var request = {
            TransactionID: TransactionID,
            AadhaarNo: AadhaarNo,
            FingerPrint: fingerPrintXML,
            MobileNo: MobileNo
        };

        var requestObj = JSON.stringify(request);

        var response = await EKYCBIOMATERIC(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        setSeverity('success');

        if (!response.status) {
            var data = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(data.Message);

            return;
        }

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setIsError(true);
            if (data.Message === 'User not onboarded') {
                history.push('/ACUserOnbording');
                return;
            }
            return;
        }

        setResponseMessage(data.Message);
        history.push('/ACAEPS');
    };

    const FormValidationSchema = Yup.object({
        AadhaarNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'AadhaarNo')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Ekyc Biomateric
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Aadhaar No"
                                                        name="AadhaarNo"
                                                        type="text"
                                                        length={12}
                                                        placeholder="Aadhaar Number"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Scan"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Scan
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </CustomContainer>
    );
};
